/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createFinancialReportFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeFinancialReport, type FinancialReport, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { DownloadRequestBuilderNavigationMetadata, type DownloadRequestBuilder } from './download/index.js';
// @ts-ignore
import { FinancialReportItemRequestBuilderRequestsMetadata, type FinancialReportItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type AdditionalDataHolder, type BaseRequestBuilder, type DateOnly, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type ParseNode, type RequestConfiguration, type RequestInformation, type RequestsMetadata, type SerializationWriter } from '@microsoft/kiota-abstractions';

/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FinancialReportPostRequestBody}
 */
// @ts-ignore
export function createFinancialReportPostRequestBodyFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFinancialReportPostRequestBody;
}
/**
 * The deserialization information for the current model
 * @param FinancialReportPostRequestBody The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFinancialReportPostRequestBody(financialReportPostRequestBody: Partial<FinancialReportPostRequestBody> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "Amount": n => { financialReportPostRequestBody.amount = n.getNumberValue(); },
        "Date": n => { financialReportPostRequestBody.date = n.getDateOnlyValue(); },
        "FormFile": n => { financialReportPostRequestBody.formFile = n.getByteArrayValue(); },
        "NumberOfSeats": n => { financialReportPostRequestBody.numberOfSeats = n.getNumberValue(); },
        "TourOperatorId": n => { financialReportPostRequestBody.tourOperatorId = n.getNumberValue(); },
    }
}
export interface FinancialReportPostRequestBody extends AdditionalDataHolder, Parsable {
    /**
     * The Amount property
     */
    amount?: number | null;
    /**
     * The Date property
     */
    date?: DateOnly | null;
    /**
     * The FormFile property
     */
    formFile?: ArrayBuffer | null;
    /**
     * The NumberOfSeats property
     */
    numberOfSeats?: number | null;
    /**
     * The TourOperatorId property
     */
    tourOperatorId?: number | null;
}
/**
 * Builds and executes requests for operations under /FinancialReport
 */
export interface FinancialReportRequestBuilder extends BaseRequestBuilder<FinancialReportRequestBuilder> {
    /**
     * The Download property
     */
    get download(): DownloadRequestBuilder;
    /**
     * Gets an item from the ApiSdk.FinancialReport.item collection
     * @param id Unique identifier of the item
     * @returns {FinancialReportItemRequestBuilder}
     */
     byId(id: number) : FinancialReportItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     */
     delete(requestConfiguration?: RequestConfiguration<FinancialReportRequestBuilderDeleteQueryParameters> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FinancialReport[]>}
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FinancialReport[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FinancialReport>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     post(body: FinancialReportPostRequestBody, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FinancialReport | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<FinancialReportRequestBuilderDeleteQueryParameters> | undefined) : RequestInformation;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: FinancialReportPostRequestBody, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
export interface FinancialReportRequestBuilderDeleteQueryParameters {
    id?: number;
}
/**
 * Serializes information the current object
 * @param FinancialReportPostRequestBody The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFinancialReportPostRequestBody(writer: SerializationWriter, financialReportPostRequestBody: Partial<FinancialReportPostRequestBody> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!financialReportPostRequestBody || isSerializingDerivedType) { return; }
    writer.writeNumberValue("Amount", financialReportPostRequestBody.amount);
    writer.writeDateOnlyValue("Date", financialReportPostRequestBody.date);
    writer.writeByteArrayValue("FormFile", financialReportPostRequestBody.formFile);
    writer.writeNumberValue("NumberOfSeats", financialReportPostRequestBody.numberOfSeats);
    writer.writeNumberValue("TourOperatorId", financialReportPostRequestBody.tourOperatorId);
    writer.writeAdditionalData(financialReportPostRequestBody.additionalData);
}
/**
 * Uri template for the request builder.
 */
export const FinancialReportRequestBuilderUriTemplate = "{+baseurl}/FinancialReport";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const FinancialReportRequestBuilderNavigationMetadata: Record<Exclude<keyof FinancialReportRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: FinancialReportItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["id"],
    },
    download: {
        navigationMetadata: DownloadRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const FinancialReportRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: "{+baseurl}/FinancialReport?id={id}",
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
    },
    get: {
        uriTemplate: FinancialReportRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createFinancialReportFromDiscriminatorValue,
    },
    post: {
        uriTemplate: FinancialReportRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFinancialReportFromDiscriminatorValue,
        requestBodyContentType: "application/x-www-form-urlencoded",
        requestBodySerializer: serializeFinancialReportPostRequestBody,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
